/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import { LayerModel } from "RosterData";
import { Box, Tooltip, Typography } from "@mui/material";
import { PaletteColor, Theme } from "@mui/material/styles";
import DynamicIcon from "../Icons/DynamicIcon";

interface LayerCellProps {
  data: LayerModel;
  continue: boolean;
}

const LayerCell = (props: LayerCellProps) => {
  return (
    <>
      {props.continue ? (
        <Box
          height={20}
          sx={(theme) => ({
            cursor: "pointer",
            backgroundColor:
              props.data.type !== "none"
                ? theme.palette.error.main
                : "transparent",
            width: "100%",
          })}
        />
      ) : (
        <Box
          // color="inherit"
          sx={(theme) => ({
            cursor: "pointer",
            display: "flex",
            backgroundColor:
              props.data.type !== "none"
                ? (
                    theme.palette[
                      props.data.type as keyof typeof theme.palette
                    ] as PaletteColor
                  ).main
                : "transparent",
            width: "100%",
          })}
        >
          <DynamicIcon
            iconName={props.data.icon}
            sx={{
              color: props.data.type !== "none" ? "white" : "inherit",
            }}
            fontSize="small"
          />
          <Typography
            sx={{
              ml: 0.5,
            }}
            variant="caption"
            color={props.data.type !== "none" ? "white" : "inherit"}
          >
            {props.data.value ? props.data.value : "No Bed"}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default LayerCell;
